import { FC, ReactNode } from "react";

import classes from "./fieldContainer.scss";

interface FieldContainerProps {
  label?: string;
  labelId?: string;
  inputId?: string;
  currency?: string;
  currencyId?: string;
  children: ReactNode;
}

const FieldContainer: FC<FieldContainerProps> = ({
  label = "",
  labelId,
  inputId,
  currency = "zł",
  currencyId,
  children,
}) => {
  return (
    <div className={classes.fieldContainer}>
      <label className={classes.label} id={labelId} htmlFor={inputId}>{label}</label>
      <div className={classes.fieldInnerContainer}>
        {children}
        <span className={classes.currency} id={currencyId} aria-hidden="true">{currency}</span>
      </div>
    </div>
  );
};

export default FieldContainer;
